var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB9583D0-3E4E-41CF-A41B-AABCA4757B0B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resource-Library",
    transform: "translate(-1213.000000, -381.000000)",
    fill: "#9C9C9C",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1194.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.861675,19.0507817 C20.861675,16.7802845 22.7087847,14.9331066 24.9792124,14.9331066 C27.2495779,14.9331066 29.0966253,16.7802845 29.0966253,19.0507817 C29.0966253,21.3211546 27.2495779,23.1680836 24.9792124,23.1680836 C22.7087847,23.1680836 20.861675,21.3211546 20.861675,19.0507817 M31.791864,25.2035624 L28.8632872,22.2751006 C29.5912324,21.3996599 30.0297911,20.2755775 30.0297911,19.0507817 C30.0297911,16.2657695 27.7640912,14 24.9792124,14 C22.1942714,14 19.9285714,16.2657695 19.9285714,19.0507817 C19.9285714,21.8356073 22.1942714,24.1011902 24.9792124,24.1011902 C26.203942,24.1011902 27.328083,23.6626923 28.2034586,22.9347447 L31.1320975,25.863331 C31.2231684,25.9544644 31.3426057,26 31.4619807,26 C31.5813558,26 31.7007931,25.9544644 31.7919262,25.863331 C31.9741302,25.6811264 31.9741302,25.385767 31.791864,25.2035624",
    id: "search"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.94507eca.svg";
export { ForwardRef as ReactComponent };